module.exports = __webpack_public_path__ + "chowtime-mockup.svg?d0b88bf89a438087dea0e97bc62fc801";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/chowtime-mockup.svg
// module id = 309
// module chunks = 0